import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/** Carte de contenu : une section = un bloc lisible, au lieu d'un long formulaire plat. */
export const ProfileCard = ({
  title,
  subtitle,
  icon,
  children,
}: {
  title: string;
  subtitle?: string;
  icon: IconProp;
  children?: React.ReactNode;
}) => (
  <section className="bg-white rounded-lg shadow-md p-4 md:p-6">
    <div className={`flex items-start gap-3 ${children ? "mb-5" : ""}`}>
      <FontAwesomeIcon icon={icon} className="text-tertiary mt-1 shrink-0" />
      <div>
        <h2 className="font-oxaniumMedium text-lg text-tertiary leading-tight">
          {title}
        </h2>
        {subtitle && (
          <p className="text-sm text-grey-readable mt-0.5">{subtitle}</p>
        )}
      </div>
    </div>
    {children}
  </section>
);
